import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Button } from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import DashboardContainer from "../../components/dashboard-container";
import NetworkDesignViewer from "../../components/network-design/NetworkDesignViewer";
import CustomTypography from "../../globalStyles/fonts";

const ViewNetworkDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const design = location.state?.design || null;

  const handleBack = () => {
    // Check if there's preview data in localStorage
    const storedData = localStorage.getItem("networkDesignPreview");
    if (storedData) {
      // Navigate back to manage page to continue editing
      navigate("/manage-network-design");
    } else {
      // Navigate to main network design page
      navigate("/network-design");
    }
  };

  return (
    <Box sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          //   variant="outlined"
          sx={{ mb: 2, width: 30 }}
        ></Button>
        <CustomTypography sx={{ mb: 1 }}>
          {design?.name || "Network Design"}
        </CustomTypography>
      </Box>
      <NetworkDesignViewer designId={design?._id} data={design} />
    </Box>
  );
};

export default ViewNetworkDesign;
